import axios from 'axios';
import { getUserToken } from '../services/Firebase/authHelper';

const apiUrl = process.env.REACT_APP_HOST;

const request = async (method, endpoint, body = null, headers = {}, requireAuth = true) => {
  const token = requireAuth ? await getUserToken() : null;
  if (requireAuth && !token) {
    throw new Error('User is not authenticated.');
  }

  if (!apiUrl) {
    throw new Error('Missing API host configuration.');
  }

  try {
    const response = await axios({
      method,
      url: `${apiUrl}/api/${endpoint}`,
      data: body,
      headers: token ? { ...headers, authorization: `Bearer ${token}` } : headers
    });
    return response.data;
  } catch (error) {
    const responseError = error?.response?.data?.error;
    const responseMessage = error?.response?.data?.message;
    const fallbackMessage = error?.message || 'Request failed';
    console.error('[API request failed]', {
      method,
      endpoint,
      status: error?.response?.status,
      error: responseError || responseMessage || fallbackMessage
    });
    throw new Error(responseError || responseMessage || fallbackMessage);
  }
};

export const get = async endpoint => request('get', endpoint);
export const post = async (endpoint, body, headers = {}) => request('post', endpoint, body, headers);
export const patch = async (endpoint, body) => request('patch', endpoint, body);
export const httpDelete = async (endpoint, body, headers = {}) => request('delete', endpoint, body, headers);
export const getPublic = async endpoint => request('get', endpoint, null, {}, false);
export const postPublic = async (endpoint, body, headers = {}) => request('post', endpoint, body, headers, false);
